export const PRODUCTION_WIDGET_RUNTIME_ENDPOINTS = {
    apiUrl: "https://widget.getuserfeedback.com/v1",
    // Release-coherent browser projection default; see docs/specs/2026-08-02-flow-interaction-model.md.
    coreUrl: "https://cdn.getuserfeedback.com/widget/core/v6/core.html",
    realtimeUrl: "wss://realtime.getuserfeedback.com/v1",
};
